import { FileDownloadOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

interface IProps {
  onExport: () => void;
  disabled?: boolean;
}

/** Per-widget CSV export (flank#4457) — same icon as the page-level Export
 * button, scaled down for a card header. */
const WidgetExportButton = ({ onExport, disabled }: IProps) => (
  <Tooltip title={disabled ? 'No data to export yet' : 'Export this chart as CSV'}>
    <span>
      <IconButton size='small' onClick={onExport} disabled={disabled} aria-label='Export as CSV'>
        <FileDownloadOutlined sx={{ fontSize: 18 }} />
      </IconButton>
    </span>
  </Tooltip>
);

export default WidgetExportButton;
